'use client';

import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { z } from 'zod';
import { toasterApi } from '@terra/ui-design-system';
import { QUIT_CONFIRMATION_WINDOW_MS } from '../electron/quit-confirmation';

const QUIT_CONFIRMATION_CHANNEL = 'app:confirm-quit';
const QUIT_CONFIRMATION_TOAST_ID = 'confirm-application-quit';

const QuitConfirmationPayloadSchema = z.object({
  shortcut: z.string().min(1),
});

function readQuitShortcut(payload: unknown): string | null {
  const result = QuitConfirmationPayloadSchema.safeParse(payload);

  return result.success ? result.data.shortcut : null;
}

export function QuitConfirmationPrompt() {
  const t = useTranslations('quitConfirmation');

  useEffect(() => {
    if (!window.electronAPI) {
      return;
    }

    const handleConfirmQuit = (payload: unknown) => {
      const shortcut = readQuitShortcut(payload);

      if (!shortcut) {
        return;
      }

      toasterApi.create({
        id: QUIT_CONFIRMATION_TOAST_ID,
        type: 'info',
        title: t('pressAgain', { shortcut }),
        duration: QUIT_CONFIRMATION_WINDOW_MS,
      });
    };

    window.electronAPI.on(QUIT_CONFIRMATION_CHANNEL, handleConfirmQuit);

    return () => {
      window.electronAPI?.removeListener(
        QUIT_CONFIRMATION_CHANNEL,
        handleConfirmQuit,
      );
    };
  }, [t]);

  return null;
}
